import React from "react";
import ReactECharts from "echarts-for-react";
import {
  blue,
  green,
  grey,
  deepPurple,
  orange,
  teal,
} from "@material-ui/core/colors";

function groupByYear(data) {
  const grouped = {};
  data.forEach((item) => {
    const date = new Date(item.createdAt);
    const year = date.getFullYear();
    if (year < 2022) return;
    const monthIndex = date.getMonth(); // 0 = Jan, 11 = Dec

    if (!grouped[year]) grouped[year] = [];
    grouped[year].push({
      monthIndex,
      value: item.totalBagsCertified,
      date,
    });
  });

  for (const year in grouped) {
    grouped[year].sort((a, b) => a.date - b.date);
  }

  return grouped;
}

export default function EChartsStockChart({ data }) {
  const groupedData = groupByYear(data);
  const allMonths = [
    "Jan", // Janeiro
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];

  const colorMap = {
    2020: teal[400],
    2021: grey[600],
    2022: orange[500],
    2023: green[500],
    2024: blue[400],
    2025: deepPurple[500],
  };

  //console.log("groupedData", groupedData);
  const currentYear = new Date().getFullYear();

  const series = Object.keys(groupedData).map((year) => ({
    name: year,
    type: "line",
    data: allMonths.map((_, index) => {
      const entriesForMonth = groupedData[year].filter(
        (e) => e.monthIndex === index,
      );
      const latestEntry = entriesForMonth.sort((a, b) => b.date - a.date)[0];
      return latestEntry ? Math.round(latestEntry.value / 1000) : null;
    }),
    connectNulls: true,
    smooth: true,
    lineStyle: {
      type: parseInt(year) === currentYear ? "solid" : "dashed",
      width: 2,
    },
    color: colorMap[year] || "#ccc",
  }));

  const option = {
    title: {
      text: "Comparativo Anual dos Estoques Certificados de Arábica na ICE",
      left: "center",
      textStyle: { color: grey[400] },
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      top: 40,
      data: Object.keys(groupedData),
      textStyle: {
        color: grey[400],
      },
    },
    xAxis: {
      type: "category",
      data: allMonths,
    },
    yAxis: {
      type: "value",
      name: "Mil sacas",
    },
    series,
    grid: { left: "10%", right: "10%", bottom: "15%" },
    toolbox: { feature: { saveAsImage: {}, dataZoom: {}, restore: {} } },
    graphic: {
      elements: [
        {
          type: "text",
          left: "center",
          top: "center",
          style: {
            text: "cafetrade.com.br",
            fontSize: 30,
            fontWeight: "bold",
            fill: "rgba(200, 200, 200, 0.3)",
          },
          z: -10,
        },
      ],
    },
  };

  return (
    <div style={{ height: "600px", width: "100%", marginTop: 40 }}>
      <ReactECharts option={option} style={{ height: "100%", width: "100%" }} />
    </div>
  );
}
